import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { engineerInfo, serviceAreas } from '../../mock';
import { Button } from '../ui/button';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-end overflow-hidden bg-gradient-to-br from-[#073A40] to-[#06323B] pb-0">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#A69076] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#F2F2F2] rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 pt-20 pb-0 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-8 items-end">
          <div className="space-y-6 pb-8 lg:pb-12">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Construa ou Regularize seu Imóvel em{' '}
              <span className="text-[#A69076]">Natal e Parnamirim</span>{' '}
              com Segurança Técnica e Zero Dor de Cabeça
            </h1>

            <p className="text-xl sm:text-2xl text-[#F2F2F2] font-medium leading-relaxed">
              Projetos completos e regularização de imóveis com prazo garantido e preço justo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                asChild
                size="lg"
                className="bg-[#A69076] hover:bg-[#A69F97] text-white font-bold text-lg sm:text-xl px-8 py-7 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                  <Phone size={22} className="mr-2" />
                  Solicitar Orçamento Gratuito
                </a>
              </Button>
            </div>

            <div className="pt-4">
              <p className="text-base sm:text-lg text-[#A69076] font-semibold mb-2">
                Atendemos em:
              </p>
              <p className="text-lg sm:text-xl text-[#F2F2F2] font-medium">
                {serviceAreas.join(' • ')}
              </p>
            </div>
          </div>

          <div className="relative flex items-end justify-center lg:justify-end h-full">
            <img 
              src={engineerInfo.heroPhoto}
              alt={`${engineerInfo.name} - Engenheira Civil`}
              className="w-auto h-full max-h-[75vh] object-contain object-bottom drop-shadow-2xl"
            />
            <div className="absolute top-10 right-0 w-64 sm:w-80 h-64 sm:h-80 bg-[#A69076] opacity-20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
